import styled from 'styled-components'

export const Content = styled.div`
	margin: 22px 0 84px;
`
